import { Association, Team } from "@entities";
import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { AssociationTeamEntityConfig } from "./config";
import { AssociationTeamFilters } from "./filters";
import { AssociationTeamMethods } from "./methods";

@HyperEntity("association-team", AssociationTeamEntityConfig)
export class AssociationTeam extends extender(
  AssociationTeamFilters,
  AssociationTeamMethods,
) {
  @Fields.string({ dbName: "team_id" })
  teamId = "";

  @Fields.string({ dbName: "association_id" })
  associationId = "";

  @Relations.toOne<AssociationTeam, Association>(() => Association, {
    fields: {
      id: "associationId",
    },
  })
  association?: Association;

  @Relations.toOne(() => Team, "teamId")
  team?: Team;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
